export default "__VITE_ASSET__6fb6ffa0__"